export const LES_MILLS_TRACKING = {
  page: 'ultrahuman-x-les-mills',
  cta: {
    hero: {
      event: 'uhx_les_mills_hero_buy_cta_click',
      dataButtonType: 'uhx_les_mills_hero_buy_button',
    },
    getStarted: {
      event: 'uhx_les_mills_get_started_buy_cta_click',
      dataButtonType: 'uhx_les_mills_get_started_buy_button',
    },
    optimize: {
      event: 'uhx_les_mills_optimize_buy_cta_click',
      dataButtonType: 'uhx_les_mills_optimize_buy_button',
    },
  },
} as const;

